@if ((orderStatus === 'WAITING_SUPPLIERS_RESPONSE' || orderStatus === 'WAITING_BUDGET_REQUEST_SUBMISSION') && !authenticationService.isApproverBudgets) {
  <div fxLayout="column">
    <form fxFlex="100" fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="space-between center" [formGroup]="budgetForm"
          #form="ngForm">
      <mat-form-field fxFlex="70" appearance="outline">
        <mat-label>{{ "budget.supplier" | translate }}</mat-label>
        <mat-select formControlName="supplier" name="supplier">
          @for (supplier of suppliers; track supplier) {
            <mat-option [value]="supplier.id">{{ supplier.cnpj }} - {{ supplier.corporateName }} - {{supplier.contactEmail}}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field fxFlex="20" appearance="outline">
        <mat-label>{{ "budget.expectedReturn" | translate }}</mat-label>
        <input formControlName="expectedReturn" name="expectedReturn" matInput [matDatepicker]="picker">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker [calendarHeaderComponent]="customHeader" #picker></mat-datepicker>
      </mat-form-field>

      <button fxFlex="10" mat-flat-button color="primary" class="add-button mg-b-22" [disabled]="!budgetForm.valid"
              (click)="addSupplierIntoBudget()">
        {{ "button.add" | translate }}
      </button>
    </form>
  </div>
}

<div *ngIf="hasInsufficientItems" class="warning-bar" fxLayout="row" fxLayoutAlign="start center">
  <mat-icon class="warning-icon" >warning</mat-icon>
  <span class="warning-text" style="margin-left: 10px;">
    Existem itens com quantidade disponível menor que a solicitada!
  </span>
</div>

<div class="budgets-dashboard-container">
  <table mat-table [dataSource]="tableData">

    @if (showSelectColumn) {
      <ng-container matColumnDef="select" style="width: 2%;">
        <th class="table-header" mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="toggleAll()" [checked]="allSelected" [indeterminate]="isIndeterminate()">
          </mat-checkbox>
        </th>
        <td class="table-data" mat-cell *matCellDef="let element">
          <mat-checkbox (change)="$event ? selectionModel.toggle(element) : null"
                        [checked]="selectionModel.isSelected(element)">
          </mat-checkbox>
        </td>
      </ng-container>
    }

    <ng-container matColumnDef="warning">
      <th class="table-header" mat-header-cell *matHeaderCellDef style="width: 2%;">
      </th>
      <td mat-cell *matCellDef="let element">
        <mat-icon *ngIf="element.itemsOvertaking > 0" class="warning-icon" style="margin-right: 8px;">warning</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="supplier">
      <th class="table-header" mat-header-cell *matHeaderCellDef style="width: 20%;">
        {{ "budget.supplier" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.supplierCorporateName || ' - ' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="budgetCreationDate">
      <th class="table-header" mat-header-cell *matHeaderCellDef style="width: 10%;">
        {{ "budget.budgetCreationDate" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.budgetCreationDate ? (element.budgetCreationDate | date:'dd/MM/yyyy - HH:mm') : '-' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="expectedReturn">
      <th class="table-header" mat-header-cell *matHeaderCellDef style="width: 10%;">
        {{ "budget.expectedReturn" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.expectedReturnDate ? (element.expectedReturnDate | date:'dd/MM/yyyy':'UTC') : '-' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="budgetResponse">
      <th class="table-header" mat-header-cell *matHeaderCellDef style="width: 10%;">
        {{ "budget.budgetResponse" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.budgetResponseDate ? (element.budgetResponseDate | date:'dd/MM/yyyy':'UTC') : '-' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="paymentTerm">
      <th class="table-header" mat-header-cell *matHeaderCellDef style="width: 10%;">
        {{ "budget.paymentTerm" | translate }}
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="getPaymentTermClass(element.paymentTermDays)">
        {{ element.paymentTermDays ? (element.paymentTermDays + ' dias') : '-' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="deliveryTerm">
      <th class="table-header" mat-header-cell *matHeaderCellDef style="width: 8%;">
        {{ "budget.deliveryTerm" | translate }}
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="getDeliveryTermClass(element.deliveryTermDays)">
        {{ element.deliveryTermDays ? (element.deliveryTermDays + ' dias') : '-' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="totalValue">
      <th class="table-header" mat-header-cell *matHeaderCellDef style="width: 10%;">
        {{ "budget.totalValue" | translate }}
      </th>
      <td mat-cell *matCellDef="let element" [ngClass]="getTotalValueClass(element.totalValue)">
        {{ element.totalValue ? (element.totalValue | number:'1.2-2') : '-' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th class="table-header" mat-header-cell *matHeaderCellDef style="width: 15%;">
        {{ "budget.status" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.status || ' - ' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th class="table-header action" mat-header-cell *matHeaderCellDef style="width: 5%;">
        {{ "budget.action" | translate }}
      </th>
      <td mat-cell class="action" *matCellDef="let element">
        <div fxLayout="row">
          @if (shouldShowEditAndDisableButtons()) {
            <button mat-icon-button class="icons"
                    (click)="navigateToBudgetInclusion(element)"
                    matTooltip="{{'button.budget-tooltip' | translate}}">
              <mat-icon class="material-symbols-outlined" style="color: black;">edit_square</mat-icon>
            </button>
            <button mat-icon-button class="icons"
                    (click)="confirmNoReturn(element)"
                    [disabled]="element.status === 'Sem Retorno'"
                    matTooltip="{{'button.no-return' | translate}}">
              <mat-icon class="material-symbols-outlined" style="color: black;">disabled_by_default</mat-icon>
            </button>
          } @else if (shouldShowViewButton()) {
            <button mat-icon-button class="icons"
                    (click)="navigateToBudgetView(element)"
                    [disabled]="element.status === 'Sem Retorno'"
                    matTooltip="{{'button.view-tooltip' | translate}}">
              <mat-icon>visibility</mat-icon>
            </button>
            @if (shouldShowApprovalButton()) {
              <button mat-icon-button class="icons"
                      (click)="openBudgetApproval(element.id)"
                      [disabled]="element.status === 'Sem Retorno'"
                      matTooltip="{{'button.approve-tooltip' | translate}}">
                <mat-icon>check</mat-icon>
              </button>
            }
          }
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>
</div>
